import React, { useState } from 'react'

import { Box, FormHelperText, Stack, TextField } from '@mui/material'
import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'
import { useUserContext } from '../../Contexts/UserConfig'
import PageSection from '../../Constants&Theme/PageSection'
import { useVesselGet } from '../../APIs/Hooks/VesselHooks'
import { delay } from '../../Functions/DelayFn'
import GridCard from '../../Components/GridCard'
import { stackGap } from '../../Constants&Theme/Spacing'
import { useStuartMutate } from '../../APIs/Hooks/PhpAPIHooks'

function VesselSwap() {
  const { playScanSound } = useGlobalContext()
  const { loginConfig } = useUserContext()
  const { setMessage } = useMessagePopupContext()
  const existingInit = { id: '', complete: false }
  const [existing, setExisting] = useState(existingInit)
  const newInit = {
    new: { id: '', complete: false },
    confirm: '',
  }
  const [newVal, setNewVal] = useState(newInit)
  const vesselQuery = useVesselGet(existing.id, existing.complete)

  const { mutate: swap } = useStuartMutate(
    `/vessel/swapVessel.php?ToVesselID=${newVal.confirm}&VesselID=${existing.id}`,
    (data) => {
      if (data?.Success) {
        setMessage({
          subject: 'Success!',
          severity: 'success',
          message: 'The swap was completed successfully',
        })
        setExisting(existingInit)
        setNewVal(newInit)
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message:
            data?.message ?? 'An unexpected error occurred swapping the vessel',
        })
      }
    },
  )
  return (
    <Box
      sx={{
        maxWidth: 'sm',
        width: 400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Swap Vessel Mode'}>
        <Stack
          gap={stackGap.col}
          width={1}
        >
          <Box>
            <TextField
              autoFocus
              id="existingVessel"
              label="Existing Vessel"
              onChange={(e) => {
                setNewVal(newInit)
                // needs to be controlled to be able to reset on complete
                setExisting({ id: e.target.value, complete: false })
              }}
              value={existing.id}
              onKeyDown={(e: any) => {
                if (
                  (e.code === 'Enter' || e.code === 'Tab') &&
                  e.target.value
                ) {
                  playScanSound(true)
                  delay(500).then(() =>
                    setExisting({ id: e.target.value, complete: true }),
                  )
                }
              }}
              fullWidth
            />
            <FormHelperText>
              Scan or enter the Vessel or Sample ID being swapped
            </FormHelperText>
          </Box>
          {vesselQuery.data && (
            <>
              <GridCard
                aria-label={'Vessel Card'}
                size={6}
                id={vesselQuery?.data?.VesselID}
                title={vesselQuery?.data?.VesselID}
                subtitle={getCodeSetLabelLookup(
                  loginConfig,
                  ['VesselTypeID'],
                  vesselQuery?.data?.VesselType,
                )}
                attributes={[
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['KV-Holdings'],
                    typeof vesselQuery?.data?.HoldingID === 'string' ?
                      parseInt(vesselQuery?.data?.HoldingID)
                    : vesselQuery?.data?.HoldingID,
                  ),
                  `Contains ${vesselQuery?.data?.Vessels?.length} Vessels & ${vesselQuery?.data?.Samples?.length} Samples`,
                ]}
              />
              <Box>
                <TextField
                  autoFocus
                  value={newVal.new.id}
                  label="New Vessel"
                  onChange={(e) =>
                    setNewVal({
                      ...newInit,
                      new: { id: e.target.value, complete: false },
                    })
                  }
                  onBlur={() => {
                    setNewVal((n) => {
                      return { ...n, new: { ...n.new, complete: true } }
                    })
                  }}
                  error={newVal.new.complete && !newVal.new.id}
                  fullWidth
                />
                <FormHelperText>
                  Scan or enter the new destination Vessel or Sample ID
                </FormHelperText>
              </Box>
            </>
          )}
          {vesselQuery.data && newVal.new.complete && newVal.new.id && (
            <Box>
              <TextField
                autoFocus
                id="confirmNewVessel"
                value={newVal.confirm}
                label="Confirm New Vessel"
                onChange={(e) =>
                  setNewVal((n) => {
                    return { ...n, confirm: e.target.value }
                  })
                }
                onKeyDown={(e: any) => {
                  if (e.code === 'Enter' || e.code === 'Tab') {
                    playScanSound(true)
                    delay(500).then(() => swap())
                  }
                }}
                fullWidth
              />
              <FormHelperText>
                Rescan or re-enter the destination Vessel or Sample ID
              </FormHelperText>
            </Box>
          )}
        </Stack>
      </PageSection>
    </Box>
  )
}

export default VesselSwap
